import React, { useState, useRef, useEffect } from "react";

/**
 * Headline results component
 * @param bCorpFields bCorpFields object
 * @returns Returns a headline results component with animated stats that count upwards
 */
const HeadlineResults = ({ bCorpFields }) => {
    return(
        <div className="b-corp-headline-result-background">    
            <div className="">
                <div className="b-corp-headline-result">
                    { bCorpFields.bCorpHeadlineResultsRepeater && bCorpFields.bCorpHeadlineResultsRepeater.map(( result, index ) => {
                        return <HeadlineResult result={ result } key={`result-card-${ index }`} />
                    })}
                </div>
            </div>
        </div>
    )
}

/**
 * Result component
 * @param result Result object
 * @returns Returns a single result component that counts up
 */
const HeadlineResult = ({ result }) => {
    const [ stat, setStat ] = useState(0);
    const [ animationStart, setAnimationStart ] = useState(true);
    const resultRef = useRef();

    let numberResult = result.bCorpHeadlineResultsRepeaterStat.match(/\d+/g);
    let suffix = result.bCorpHeadlineResultsRepeaterStat.match(/[^\d]+$/g);
    let prefix = result.bCorpHeadlineResultsRepeaterStat.match(/^[^\d]+/g);

    if(suffix) {
        suffix = suffix.join("");
    }else{
        suffix = "";
    }
    if(prefix) {
        prefix = prefix.join("");
    }else{
        prefix = "";
    }
    
    const count = (stat) => {
        let statTick = 50;
        if( parseFloat(stat) < numberResult[0] && animationStart ) {
            let inc = numberResult[0] / 20;

            if(inc < 1) {
                inc = 1;
                statTick *= 3;
            }

            setTimeout(() => {
                setStat((parseFloat(stat) + parseFloat(inc)).toFixed(0));
                count(parseFloat(stat) + parseFloat(inc));
            }, statTick)

        }else{

            if(parseInt(result.bCorpHeadlineResultsRepeaterStat) > 999) {
                setStat(result.bCorpHeadlineResultsRepeaterStat.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
            }else{
                setStat(result.bCorpHeadlineResultsRepeaterStat);
            }

            setAnimationStart(false);
        }
    }

    useEffect(() => {
        const observer = new IntersectionObserver(entries => {   
          if (entries[0].isIntersecting) {
          
            count(stat);

            observer.unobserve(resultRef.current);
          }
        });
        observer.observe(resultRef.current);
        
        return () => observer.disconnect();
    });

    return(
        <div ref={ resultRef } className="b-corp-headline-result-wrapper">
            { animationStart ?
                <h3 className="b-corp-headline-result-stat">{prefix + stat + suffix}</h3>
            :
                <h3 className="b-corp-headline-result-stat">{stat}</h3>
            }
            <h4 className="b-corp-headline-result-title">{result.bCorpHeadlineResultsRepeaterTitle}</h4>
        </div>
    )
};

export default HeadlineResults;